import React from 'react';
import {
  DateField,
  Labeled, SelectInput,
  TextInput,
} from 'react-admin';
import moment from 'moment';
import { citizenshipLabels } from '../../../helpers/mappings';
import { formatString, validatePrimaryAddress, validateSecondaryAddress } from '../../../helpers/utils';
import '../styles.css';
import { isRequired } from '../../../validators';
import StateChoices from '../../../helpers/states';

export default (props) => {
  const { record } = props;
  const { identity } = record;
  if (!identity) {
    return null;
  }
  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <tr>
          <td style={{ width: '50%' }}>
            <Labeled label="Citizenship">
              <span className="normalField">{citizenshipLabels[identity.citizenship]}</span>
            </Labeled>
          </td>
          <td style={{ width: '50%' }}>
            <Labeled label="Country of Residence">
              <span className="normalField">{identity.residenceCountry}</span>
            </Labeled>
          </td>
        </tr>
        <tr>
          <td>
            <Labeled label="Social Security Number">
              <span className="normalField">{formatString(identity.taxIdNum, '###-##-####')}</span>
            </Labeled>
          </td>
          <td>
            <Labeled label="Date of Birth">
              <span>
                <DateField source="identity.dateOfBirth" record={record} style={{ display: 'inline-block' }} />
                <span className="normalField">&nbsp;({moment(identity.dateOfBirth).fromNow(true)} old)</span>
              </span>
            </Labeled>
          </td>
        </tr>
        <tr>
          <td>
            <TextInput style={{ width: '50%' }} source="identity.primaryAddress.line1" label="Address Line 1" validate={validatePrimaryAddress} />
          </td>
          <td>
            <TextInput style={{ width: '50%' }} source="identity.primaryAddress.line2" label="Address Line 2" validate={validateSecondaryAddress} />
          </td>
        </tr>
        <tr>
          <td>
            <TextInput style={{ width: '50%' }} source="identity.primaryAddress.city" label="City" validate={isRequired} />
          </td>
          <td>
            <SelectInput
              source="identity.primaryAddress.state"
              label="State"
              choices={StateChoices}
              validate={isRequired}
              style={{ width: '50%' }}
            />
          </td>
        </tr>
        <tr>
          <td>
            <SelectInput style={{ width: '50%' }} source="identity.primaryAddress.country" label="Country" choices={[{ id: 'US', name: 'US' }]} validate={isRequired} />
          </td>
          <td>
            <TextInput style={{ width: '50%' }} source="identity.primaryAddress.zipcode" label="Zip Code" validate={isRequired} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};




// WEBPACK FOOTER //
// ./src/components/User/children/Identity.jsx